const GameOperationPolicy = () => {
    return (
        <div className='game-operation-policy'>
            <div role='tabpanel'>
                <h4>
                    <strong>Política de Operação de Jogo</strong>
                </h4>
                <p>
                    <strong>
                        Última revisão: 24 de outubro de 2024Data de vigência:
                        24 de outubro de 2024
                    </strong>
                </p>
                <p>
                    Ao participar da comunidade NetDoor, você se juntará a
                    muitos outros jogadores. Nós entendemos que, em uma grande
                    base de jogadores, às vezes podem ocorrer disputas e
                    mal-entendidos. No entanto, nossos funcionários no
                    jogo/online farão o possível para resolver esses problemas à
                    medida que surgirem.
                </p>
                <p>
                    Existem várias situações que podem levar a ações
                    disciplinares contra sua conta nos fóruns e dentro do jogo.
                    Se houver incidentes que perturbem a comunidade, violações
                    dos termos de serviço ou outras ações que os funcionários da
                    NetDoor considerem inadequadas, medidas apropriadas serão
                    tomadas. Todas as políticas e contratos que regulamentam o
                    uso dos serviços de jogos e interativos da NetDoor podem ser
                    verificados online aqui.
                </p>
                <p>
                    Esta política de operação de jogo descreve as regras que
                    devem ser seguidas para garantir que os jogos, fóruns e
                    outros serviços interativos oferecidos pela NetDoor através
                    do
                    <a href='http://www.plyosgames.com'>
                        {' '}
                        www.plyosgames.com
                    </a>{' '}
                    e sites associados ou via dispositivos móveis, sejam seguros
                    e agradáveis para todos.
                </p>
                <p>
                    <strong>Uso Geral dos Serviços</strong>
                </p>
                <p>
                    Você não pode utilizar os jogos e serviços interativos da
                    NetDoor de forma não intencionada pela NetDoor ou para fins
                    ilegais. Solicitamos que utilize nossos jogos e serviços
                    interativos de forma respeitosa com todos os jogadores. Além
                    disso, os administradores nunca pedirão sua senha. A
                    proteção das informações da sua conta é de sua
                    responsabilidade, então certifique-se de alterar sua senha
                    periodicamente e administrar esses dados com cuidado. As
                    informações da sua conta não devem ser compartilhadas com
                    terceiros. Qualquer consequência decorrente do
                    compartilhamento das informações da conta é de sua
                    responsabilidade, e a NetDoor não se responsabiliza por
                    isso.
                </p>
                <p>
                    <strong>Restrições Técnicas</strong>
                </p>
                <p>
                    Você não pode usar nossos jogos ou serviços interativos para
                    transmitir software ou outros materiais que contenham vírus,
                    worms, cavalos de Troia, defeitos, bombas-relógio, bombas de
                    tempo ou outros elementos de natureza destrutiva. Não envie
                    spam ou pratique flooding.
                </p>
                <p>
                    Você não deve remover, alterar ou ocultar notificações de
                    direitos autorais, marcas registradas, patentes ou outros
                    avisos de direitos proprietários incluídos nos jogos ou
                    serviços interativos da NetDoor.
                </p>
                <p>
                    Sem a nossa prévia aprovação por escrito, você não pode
                    "enquadrar" (frame) ou "espelhar" (mirror) qualquer parte
                    dos nossos jogos, sites ou serviços interativos.
                </p>
                <p>
                    Você não pode usar robôs, spiders, aplicativos de
                    pesquisa/consulta de sites ou quaisquer outros dispositivos
                    ou processos manuais ou automáticos para pesquisar, indexar,
                    "minerar dados", ou de qualquer forma replicar ou contornar
                    a estrutura de navegação, apresentação ou qualquer conteúdo
                    incluído nos jogos ou serviços interativos.
                </p>
                <p>
                    Você não pode coletar ou reunir informações sobre visitantes
                    dos nossos sites, jogadores, ou usuários de serviços
                    interativos sem nosso consentimento explícito (o qual pode
                    ser fornecido periodicamente na forma de uma API).
                </p>
                <p>
                    Salvo se expressamente permitido por contrato com a NetDoor,
                    você não pode baixar, copiar, reproduzir, redistribuir,
                    carregar, publicar, transmitir, modificar, distribuir ou
                    exibir publicamente qualquer conteúdo ou informação incluída
                    nos jogos ou serviços interativos.
                </p>
                <p>
                    Você não pode hospedar, emular ou redirecionar os protocolos
                    de comunicação que usamos (ou que nossos representantes
                    designados usam) como parte dos nossos jogos ou serviços
                    interativos, incluindo, mas não se limitando a, emulação de
                    protocolos, tunelamento, engenharia reversa, sniffing de
                    pacotes, redirecionamento, looping, ou modificação do
                    software de jogo ou programas de hospedagem.
                </p>
                <p>
                    Você não pode limitar ou interferir com o uso de serviços
                    por outras pessoas, incluindo, mas não se limitando a,
                    práticas de "hacking" ou qualquer método que comprometa o
                    serviço.
                </p>
                <p>
                    Você não pode atacar ou tentar interromper os servidores
                    usados em conexão com nossos serviços.
                </p>
                <p>
                    <strong>Trapaça</strong>
                </p>
                <p>
                    Você não deve explorar erros de design, funções não
                    documentadas e/ou bugs para obter acesso que normalmente não
                    estaria disponível ou para ganhar uma vantagem competitiva.
                </p>
                <p>
                    Em caso de bugs, avise os administradores (
                    <a href='https://plyosgames.freshdesk.com/support/tickets/new'>
                        https://plyosgames.freshdesk.com/support/tickets/new
                    </a>
                    ). Também é proibido explicar a outros como explorar bugs ou
                    usar macros.
                </p>
                <p>
                    Você não deve modificar o software fornecido como parte dos
                    jogos ou serviços interativos para alterar o serviço. Isso
                    inclui, mas não se limita à criação de trapaças e/ou hacks,
                    ou ao uso de software de terceiros para acessar arquivos que
                    fornecemos.
                </p>
                <p>
                    Você não pode realizar engenharia reversa, sniffing de
                    pacotes, descompilar ou desmontar o todo ou parte dos jogos
                    ou serviços interativos.
                </p>
                <p>
                    Você não deve usar macros (ex.: "macroteamento"), auto-loot
                    ou jogabilidade automatizada (ex.: "botting") ou qualquer
                    outra ação que permita ao seu personagem realizar funções
                    automaticamente, esteja você presente ou não.
                </p>
                <p>
                    O uso de "sniffing de pacotes", scripts e/ou software de
                    macro para qualquer propósito é proibido, assim como
                    monitorar o fluxo de dados gerados nos jogos e serviços
                    interativos.
                </p>
                <p>
                    <strong>Comunicação Inapropriada</strong>
                </p>
                <p>
                    Você não deve tentar obter senhas ou outras informações
                    pessoais de contas de outros usuários ou participantes dos
                    serviços.
                </p>
                <p>
                    Você não pode, de forma alguma, divulgar informações
                    pessoais de outros usuários (nome verdadeiro, endereço real,
                    endereço IP, endereço de e-mail, número de telefone, número
                    de cartão de crédito, etc.). Essas informações podem ser
                    usadas por terceiros para fins ilegais ou prejudiciais.
                </p>
                <p>
                    Você é totalmente responsável pela segurança das informações
                    da sua conta e pelos dados pessoais que possam
                    identificá-lo.
                </p>
                <p>
                    Você não deve, de maneira alguma, sugerir ou implicar que
                    suas declarações ou ações são apoiadas pela NetDoor.
                </p>
                <p>
                    Você não deve vender, anunciar ou postar informações
                    relacionadas a hacking, servidores privados (incluindo
                    código-fonte), gold farming, ou vender, anunciar ou postar
                    informações sobre hacking de outros softwares ou sites.
                </p>
                <p>
                    Não é permitido usar nossos jogos ou serviços interativos
                    para enviar anúncios, solicitações, correntes, esquemas de
                    pirâmide, oportunidades de investimento ou outras
                    comunicações comerciais não solicitadas.
                </p>
                <p>
                    Conversas não relacionadas ao jogo que dominem uma parte
                    significativa dos fóruns, bate-papo ou espaços de bate-papo
                    dentro do jogo, e que impeçam outros usuários de encontrar
                    informações sobre o jogo, podem ser consideradas uma
                    violação da política de operação do jogo.
                </p>
                <p>
                    <strong>
                        Violação de Direitos de Propriedade Intelectual ou
                        Outros Direitos Proprietários
                    </strong>
                </p>
                <p>
                    Não é permitido o uso não autorizado da propriedade
                    intelectual de terceiros, incluindo, mas não se limitando a,
                    software, música, obras de arte, e outros materiais
                    protegidos por direitos autorais, marcas registradas,
                    patentes ou segredos comerciais.
                </p>
                <p>
                    Você não pode transmitir informações confidenciais e
                    importantes da empresa por meio dos jogos ou serviços
                    interativos sem a devida autorização da empresa.
                </p>
                <p>
                    Você não deve se passar por outra pessoa (incluindo
                    celebridades), fingir ser um funcionário da NetDoor ou um
                    agente da NetDoor (incluindo GMs), nem tentar enganar os
                    usuários afirmando representar a NetDoor ou seus parceiros
                    ou afiliados.
                </p>
                <p>
                    <strong>Assédio</strong>
                </p>
                <p>
                    Comportamentos rudes, ilegais, de assédio, obscenos,
                    vulgares, odiosos, ameaçadores, abusivos ou repreensíveis de
                    qualquer outra forma não são permitidos. Isso inclui, mas
                    não se limita a, ações como matar, roubar ou pilhar de forma
                    intencional, bem como fazer declarações sexuais ou outras
                    declarações inadequadas.
                </p>
                <p>
                    Você não pode assediar, abusar, ameaçar, insultar, enviar
                    spam, gritar, intimidar ou perseguir outros usuários, nem
                    incentivar outros jogadores a fazê-lo.
                </p>
                <p>
                    Você não deve promover danos ou violência contra pessoas ou
                    animais, nem encorajar de qualquer forma a automutilação.
                </p>
                <p>
                    Você não pode criar ou compartilhar qualquer um dos
                    seguintes conteúdos por meio de nossos jogos ou serviços
                    interativos.
                </p>
                <ol>
                    <li>
                        <strong>Conteúdos Sexuais ou Provocativos</strong>
                    </li>
                </ol>
                <p>
                    Não é permitido postar qualquer conteúdo que uma pessoa
                    razoável possa considerar voltado para adultos ou quase
                    adultos, ou que se enquadre na categoria de pornografia de
                    forma geral.
                </p>
                <ol>
                    <li>
                        <strong>Interferência no Jogo Normal</strong>
                    </li>
                </ol>
                <p>
                    Você não deve interromper as atividades normais de jogo de
                    outras pessoas. Atrasos intencionais no andamento do jogo,
                    jogar deliberadamente para permitir que o time adversário
                    ganhe em partidas em equipe, se recusar a jogar
                    intencionalmente, sair propositalmente do jogo, ou insultar
                    outros jogadores durante a partida também podem ser
                    considerados jogadas anormais, conforme a avaliação do
                    administrador.
                </p>
                <ol>
                    <li>
                        <strong>
                            Uso Proibido de Jogos e Serviços Interativos
                        </strong>
                    </li>
                </ol>
                <p>
                    Você não pode utilizar o jogo ou os serviços interativos
                    para fins comerciais, como venda de contas, venda de VC ou
                    itens no jogo, ou oferecer serviços de "power leveling".
                </p>
                <p>
                    É proibido todo o conteúdo que promova ou incentive jogos de
                    azar ilegais, conteúdos ilícitos, pornografia, pirataria,
                    farmácias online ilegais, drogas ilícitas ou atividades
                    criminosas.
                </p>
                <p>
                    Não crie ou compartilhe conteúdo que ensine os usuários a
                    fabricar bombas, armas ou drogas, ou que incentive atos
                    violentos ou ilegais conforme a legislação aplicável.
                </p>
                <p>
                    É proibido qualquer conteúdo que promova ou incentive o
                    consumo de álcool por menores, uso de drogas ilegais ou
                    comportamento socialmente irresponsável relacionado ao uso
                    de álcool ou drogas (ex.: dirigir embriagado).
                </p>
                <p>
                    Não crie ou compartilhe conteúdo que promova ou envolva
                    ameaças de terrorismo ou atividades terroristas.
                </p>
                <p>
                    É proibido criar ou compartilhar conteúdo que promova ou
                    faça referência a vírus ou malware.
                </p>
                <p>
                    Também é proibido o uso de nomes inapropriados em qualquer
                    conteúdo de jogo, como nomes de personagens, nomes de
                    guildas, ou nomes de lojas pessoais.
                </p>
                <p>
                    Não ofenda outros usuários por causa de sua orientação
                    sexual e/ou identidade de gênero.
                </p>
                <p>
                    Não menospreze outros usuários com base em sua religião,
                    local de residência, raça ou deficiência.
                </p>
                <p>
                    Não crie ou compartilhe conteúdo que facilite ou encoraje o
                    roubo de identidade.
                </p>
                <p>
                    <strong>Consequências da Violação</strong>
                </p>
                <p>
                    Se você violar as regras de operação do jogo, podem ser
                    tomadas medidas para resolver a infração, incluindo, mas não
                    se limitando a, suspensão temporária, banimento permanente
                    do personagem/jogo ou bloqueio permanente de IP (impedindo o
                    acesso aos jogos ou serviços interativos da NetDoor). A
                    NetDoor determinará o processo adequado para lidar com as
                    violações das políticas de operação do jogo.
                </p>
                <p>
                    Os exemplos abaixo representam o mínimo de ações para casos
                    comuns, mas as medidas reais serão decididas pela NetDoor de
                    acordo com a avaliação final dos administradores.
                </p>
                <style>{`
                    .policy-table {
                        width: 100%;
                        border-collapse: collapse;
                        margin: 0 auto 2rem auto;
                        font-size: 1rem;
                        table-layout: fixed;
                    }
                    .policy-table th, .policy-table td {
                        text-align: center;
                        padding: 8px;
                        border: none;
                    }
                    .policy-table thead th {
                        background: #f2a311;
                        color: #000;
                        font-size: 1rem;
                        word-break: break-all;
                    }
                    .policy-table .row-orange {
                        background: #f2a311;
                    }
                    .policy-table .row-orange td,
                    .policy-table .row-orange .offense-cell {
                        color: #000;
                    }
                    .policy-table .offense-cell {
                        font-weight: bold;
                    }
                `}</style>
                <figure>
                    <table className='policy-table'>
                        <thead>
                            <tr>
                                <th>fensa</th>
                                <th>Mínimo</th>
                                <th>Máximo</th>
                                <th>2ª Ofensa Mínimo</th>
                                <th>2ª Ofensa Máximo</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className='offense-cell'>
                                    Assédio no Jogo / Fórum
                                </td>
                                <td>Advertência / Silenciamento</td>
                                <td>Suspensão Temporária (30 dias)</td>
                                <td>1ª Punição * 2</td>
                                <td>Suspensão Permanente</td>
                            </tr>
                            <tr className='row-orange'>
                                <td className='offense-cell'>
                                    Impersonação de Funcionários / CAs
                                </td>
                                <td>Advertência / Silenciamento</td>
                                <td>Suspensão Temporária (30 dias)</td>
                                <td>1ª Punição * 2</td>
                                <td>Suspensão Permanente</td>
                            </tr>
                            <tr>
                                <td className='offense-cell'>
                                    Disseminação de Boatos
                                </td>
                                <td>Advertência / Silenciamento</td>
                                <td>Suspensão Temporária (30 dias)</td>
                                <td>1ª Punição * 2</td>
                                <td>Suspensão Permanente</td>
                            </tr>
                            <tr className='row-orange'>
                                <td className='offense-cell'>
                                    Abuso no Chat ou Spam
                                </td>
                                <td>Advertência / Silenciamento</td>
                                <td>Suspensão Temporária (30 dias)</td>
                                <td>1ª Punição * 2</td>
                                <td>Suspensão Permanente</td>
                            </tr>
                            <tr>
                                <td className='offense-cell'>Denúncia Falsa</td>
                                <td>Advertência</td>
                                <td>Suspensão Temporária (30 dias)</td>
                                <td>1ª Punição * 2</td>
                                <td>Suspensão Permanente</td>
                            </tr>
                            <tr className='row-orange'>
                                <td className='offense-cell'>
                                    Exploração de Bugs
                                </td>
                                <td>Advertência / Suspensão Temporária</td>
                                <td>Suspensão Permanente</td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td className='offense-cell'>
                                    Exploração de Mecânicas do Jogo
                                </td>
                                <td>Advertência / Suspensão Temporária</td>
                                <td>Suspensão Permanente</td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr className='row-orange'>
                                <td className='offense-cell'>
                                    Exploração de Programas
                                </td>
                                <td>Suspensão Temporária</td>
                                <td>Suspensão Permanente</td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td className='offense-cell'>
                                    Fraude e Roubo de Conta
                                </td>
                                <td>Suspensão Permanente</td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr className='row-orange'>
                                <td className='offense-cell'>
                                    Estorno (Chargeback)
                                </td>
                                <td>Suspensão Permanente</td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td className='offense-cell'>
                                    Anúncio de Terceiros (RWT)
                                </td>
                                <td>Suspensão Permanente</td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr className='row-orange'>
                                <td className='offense-cell'>
                                    Comércio no Mundo Real
                                </td>
                                <td>Suspensão Permanente</td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </figure>
                <ol>
                    <li>
                        Em caso de incidentes como assédio, você deve denunciar
                        dentro de 5 dias.&nbsp;
                    </li>
                    <li>
                        Se você responder à provocação de outra pessoa, como
                        insultos ou difamação, poderá ser excluído do processo
                        de denúncia ou ambos poderão ser punidos. Não provoque
                        nem responda a provocações.
                    </li>
                    <li>
                        Ao denunciar, é necessário apresentar evidências
                        objetivas (vídeo ou captura de tela, bem como a data e
                        hora exatas do incidente).
                    </li>
                    <li>
                        Em caso de roubo de conta, a denúncia deve ser feita
                        dentro de 10 dias após o ocorrido.&nbsp;
                    </li>
                    <li>
                        A responsabilidade pela comprovação do roubo de conta é
                        inteiramente do denunciante.&nbsp;
                    </li>
                    <li>
                        Se a conta foi compartilhada com outra pessoa, envolvida
                        em transações monetárias ou outras formas de negociação
                        com terceiros, se a verificação de identidade falhar, se
                        a segunda senha foi definida de forma muito simples ou
                        igual à senha da conta, se programas ilegais foram
                        usados ou se as informações fornecidas pelo denunciante
                        forem incorretas, a empresa não poderá confirmar o roubo
                        da conta.&nbsp;
                    </li>
                    <li>
                        Qualquer questão relacionada ao roubo de conta será de
                        sua responsabilidade, e a empresa não garante qualquer
                        compensação ou restauração relacionada à recuperação da
                        conta, envio de presentes, venda de itens no jogo ou
                        expiração de itens temporários.
                    </li>
                    <li>
                        As denúncias podem ser enviadas por meio do link:
                        <a href='https://plyosgames.freshdesk.com/support/tickets/new'>
                            {' '}
                            https://plyosgames.freshdesk.com/support/tickets/new
                        </a>
                        .
                    </li>
                </ol>
                <p></p>
                <p>
                    A NetDoor não tem a obrigação de enviar um aviso antes que
                    essas ações ocorram. Se sua conta for suspensa enquanto você
                    participa de um torneio ou competição, a NetDoor não se
                    responsabiliza por qualquer perda de prêmios ou
                    reconhecimento potencial relacionados ao torneio ou
                    competição.
                </p>
                <p>
                    A NetDoor não é obrigada a monitorar todas as postagens ou
                    atividades, mas reserva-se o direito de excluir qualquer
                    postagem ou tomar medidas contra qualquer usuário a qualquer
                    momento. Além disso, a NetDoor tem o direito de remover, a
                    qualquer momento e sem aviso prévio, qualquer conteúdo,
                    conta ou dispositivo criado por usuários nos jogos ou
                    serviços interativos, se considerar que viola as políticas
                    de operação do jogo ou os termos de serviço.
                </p>
                <p>
                    Se você receber uma suspensão permanente, todas as licenças
                    de conteúdo associadas à conta suspensa e qualquer saldo de
                    moeda virtual serão perdidos, e não haverá procedimento de
                    compensação.
                </p>
                <p>
                    Mesmo que você seja punido de acordo com os procedimentos de
                    operação do jogo, isso não elimina problemas legais
                    relacionados ao seu comportamento inadequado, e você poderá
                    enfrentar punições adicionais de acordo com os processos
                    legais pertinentes.
                </p>
            </div>
        </div>
    );
};

export default GameOperationPolicy;
